/* import __COLOCATED_TEMPLATE__ from './sq-summary-multi-line-chart.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { scheduleOnce, run } from '@ember/runloop';
import EmberObject, { computed } from '@ember/object';
import { observes } from '@ember-decorators/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import * as d3 from 'd3';
import * as ChartHelper from '@dashboard/shared-ui/utils/chart-helper';
import { measureText } from '@dashboard/shared-ui/utils/measure';
import { isNone } from '@ember/utils';
import $ from 'jquery';

/*
 * @todo Example usage (for now checkout use in Sales Trends Report)
 *
 * @param data {array} - primary data source to visualize; an array of arrays (assuming they are of equal length) will be compared
 * @param tick {string} - label for the x-axis
 */
let SqSummaryMultiLineChart = (_dec = computed('margin.{left,right}', 'resizable.elementWidth'), _dec2 = computed('margin.{bottom,top}', 'resizable.elementHeight'), _dec3 = computed('width'), _dec4 = computed('height'), _dec5 = computed('margin.{left,top}'), _dec6 = computed('height'), _dec7 = computed('data'), _dec8 = computed('data'), _dec9 = computed('yDomain', 'yTickFormatType'), _dec10 = computed('xDomain', 'xRange'), _dec11 = computed('xDomain', 'xRange'), _dec12 = computed('yDomain', 'yRange'), _dec13 = computed('data'), _dec14 = computed('width'), _dec15 = computed('height'), _dec16 = computed('element'), _dec17 = computed('yDomain', 'yTickSize'), _dec18 = computed('defaultMarginBottom', 'defaultMarginRight', 'defaultMarginTop', 'yAxisDigitWidth', 'yAxisSpacing', 'yDomain', 'yMaxLabel'), _dec19 = observes('data', 'width', 'height'), _dec20 = computed('data'), _class = class SqSummaryMultiLineChart extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "screen", _descriptor, this);
    _initializerDefineProperty(this, "resizable", _descriptor2, this);
    _defineProperty(this, "yTickFormatType", null);
    _defineProperty(this, "yTickFormat", null);
    _defineProperty(this, "defaultMarginLeft", 0);
    _defineProperty(this, "defaultMarginRight", 0);
    _defineProperty(this, "defaultMarginTop", 12);
    _defineProperty(this, "defaultMarginBottom", 30);
    _defineProperty(this, "yAxisDigitWidth", 8);
    _defineProperty(this, "yAxisSpacing", 16);
    _defineProperty(this, "showXGrid", true);
    _defineProperty(this, "dotRadius", 3);
  }
  init(...args) {
    super.init(...args);
    scheduleOnce('afterRender', this, this.draw);
  }
  get width() {
    return this.resizable.elementWidth - this.margin?.left - this.margin?.right;
  }
  get height() {
    const height = this.resizable.elementHeight - this.margin?.top - this.margin?.bottom;
    return height > 0 ? height : 0;
  }
  get xRange() {
    return [0, this.width];
  }
  get yRange() {
    return [this.height, 0];
  }
  get groupTransform() {
    return `translate(${this.margin?.left},${this.margin?.top})`;
  }
  get xAxisTransform() {
    return `translate(0,${this.height})`;
  }
  get xDomain() {
    return ChartHelper.xDomain(this.data);
  }
  get yDomain() {
    return ChartHelper.yDomain(this.data);
  }
  get yMaxLabel() {
    return ChartHelper.yMaxLabel(this.yDomain, this.yTickFormatType);
  }
  get xScale() {
    return d3.scale.ordinal().rangePoints(this.xRange, 1).domain(this.xDomain);
  }
  get xHoverScale() {
    return d3.scale.ordinal().rangeBands(this.xRange, 0.1, 0).domain(this.xDomain);
  }
  get yScale() {
    return ChartHelper.yScale(this.yDomain, this.yRange);
  }
  get xTickFormat() {
    return ChartHelper.xTickFormat(this.data);
  }
  get yGridTickSize() {
    return ChartHelper.yGridTickSize(this.width);
  }
  get xGridTickSize() {
    return -this.height;
  }
  get svg() {
    return d3.select($(this.element) // eslint-disable-line ember/no-jquery
    .find('.multi-line-chart__svg').get(0));
  }
  get yTicks() {
    return this.yTickSize ? [Math.min(this.yTickSize, this.yDomain[1])] : null;
  }
  get margin() {
    let yDomainDigits = 0;
    let leftSpacing = this.yAxisSpacing;

    // TODO: Remove when all charts that use this mixin sets this field explicitly
    if (isNone(this.yMaxLabel)) {
      const yDomain = this.yDomain;
      const yDomainMax = yDomain && yDomain.length > 0 ? Math.max(...yDomain) : 1;
      if (yDomainMax !== 0) {
        yDomainDigits = Math.round(yDomainMax).toString().length;
      }
      leftSpacing += this.yAxisDigitWidth * yDomainDigits;
    } else {
      leftSpacing += measureText(this.yMaxLabel);
    }
    return EmberObject.create({
      left: leftSpacing,
      right: this.defaultMarginRight,
      top: this.defaultMarginTop,
      bottom: this.defaultMarginBottom
    });
  }
  didInsertElement() {
    super.didInsertElement();
    this.resizable.registerResizeHandler(this.element);
  }
  willDestroyElement() {
    super.willDestroyElement();
    this.resizable.deregisterResizeHandler();
  }

  // eslint-disable-next-line ember/no-observers
  _observeAllTheThings() {
    return scheduleOnce('afterRender', this, this.draw);
  }
  draw() {
    if (this.data && this.width && this.height) {
      this._drawLines();
      this._drawDots();
      this._drawHover();
    }
  }
  _drawLines() {
    // clear previously set lines
    const main = this.svg.select('.multi-line-chart__main');
    main.selectAll('.multi-line-chart__line').remove();
    const xScale = this.xScale;
    const yScale = this.yScale;
    const line = d3.svg.line().x(d => xScale(d.x)).y(d => yScale(d.y));
    [...this.data].reverse().forEach(data => {
      const layer = this.data.indexOf(data);
      const lineLayer = main.append('g').attr('class', `multi-line-chart__line multi-line-chart__line--${layer}`);
      lineLayer.append('path');
      lineLayer.select('path').datum(data).attr('d', line);
    });
  }
  _drawDots() {
    const xScale = this.xScale;
    const yScale = this.yScale;
    this.data.forEach((data, i) => {
      const main = this.svg.select(`.multi-line-chart__line--${i}`);
      const dots = main.selectAll(`.multi-line-chart__dot--${i}`).data(data);
      dots.exit().remove();
      dots.enter().append('g').attr('class', `multi-line-chart__dot multi-line-chart__dot--${i}`);
      dots.append('circle');
      dots.select('circle').attr('r', this.dotRadius).attr('cx', d => xScale(d.x)).attr('cy', d => yScale(d.y)).classed('highlight', d => d.highlight);
    });
  }
  get dataForHover() {
    return ChartHelper.dataForHover(this.data);
  }
  _drawHover() {
    const data = this.dataForHover;
    if (data === null) {
      return;
    }
    const height = this.height;
    const xScale = this.xScale;
    const xHoverScale = this.xHoverScale;
    const yScale = this.yScale;
    const margin = this.margin;
    const overlay = this.svg.select('.multi-line-chart__overlay');
    const hoverWidth = xHoverScale.rangeBand();
    const barWidth = xScale.rangeBand();
    const hoverShapes = overlay.selectAll('.multi-line-chart__overlay-hover-shape').data(data);
    hoverShapes.exit().remove();
    hoverShapes.enter().append('rect').classed('multi-line-chart__overlay-hover-shape', true).style('opacity', 0);
    hoverShapes.attr('x', d => xScale(d.x) - (hoverWidth - barWidth) / 2).attr('y', 0).attr('width', xHoverScale.rangeBand()).attr('height', height).on('mouseover', d => run(() => {
      this.set('hasHoveredElement', true);
      return this.set('hoverData', {
        left: margin.get('left') + xScale(d.x) + barWidth / 2,
        bottom: height - yScale(d.y) + margin.get('bottom'),
        tooltipSections: d.tooltipSections
      });
    })).on('mouseout', () => run(() => {
      return this.set('hasHoveredElement', false);
    }));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "screen", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "resizable", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "width", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "width"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "height", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "height"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "xRange", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "xRange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "yRange", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "yRange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "groupTransform", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "groupTransform"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "xAxisTransform", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "xAxisTransform"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "xDomain", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "xDomain"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "yDomain", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "yDomain"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "yMaxLabel", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "yMaxLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "xScale", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "xScale"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "xHoverScale", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "xHoverScale"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "yScale", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "yScale"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "xTickFormat", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "xTickFormat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "yGridTickSize", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "yGridTickSize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "xGridTickSize", [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, "xGridTickSize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "svg", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "svg"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "yTicks", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "yTicks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "margin", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "margin"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_observeAllTheThings", [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, "_observeAllTheThings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dataForHover", [_dec20], Object.getOwnPropertyDescriptor(_class.prototype, "dataForHover"), _class.prototype), _class);
export { SqSummaryMultiLineChart as default };